import { store } from '@/firebase'
import { CollectionName, FSInput } from '@WombatTechnology/nitte-time-lib'

import { sortBy } from 'es-toolkit/compat'
import {
  collection,
  CollectionReference,
  deleteDoc,
  doc,
  DocumentReference,
  getDocs,
  setDoc
} from 'firebase/firestore'
import { toData } from '../toData'

export class Input {
  constructor(
    readonly data: FSInput,
    readonly ref: DocumentReference<FSInput>
  ) {}

  static async builds(
    collectionRef: CollectionReference<FSInput>
  ): Promise<Input[]> {
    const qs = await getDocs(collectionRef)
    const inputs: Input[] = await Promise.all(
      qs.docs.map((doc) => Input.build(doc.ref))
    )
    return sortBy(inputs, (i) => i.data.index)
  }

  static async build(ref: DocumentReference<FSInput>) {
    const data = await toData(ref)
    return new Input(data, ref)
  }

  static doc(teamId: string, formId: string, inputId: string) {
    return doc(this.collection(teamId, formId), inputId)
  }

  static collection(teamId: string, formId: string) {
    // TODO: FORM ColectionNameを使う
    return collection(
      store,
      `${CollectionName.Teams}/${teamId}/Forms/${formId}/Inputs`
    ) as CollectionReference<FSInput>
  }

  static collectionFromFormPath(
    formPath: string
  ): CollectionReference<FSInput> {
    return collection(
      store,
      `${formPath}/Inputs`
    ) as CollectionReference<FSInput>
  }

  static async set(
    teamId: string,
    formId: string,
    inputId: string,
    data: FSInput
  ) {
    return setDoc(this.doc(teamId, formId, inputId), data)
  }

  delete() {
    return deleteDoc(this.ref)
  }
}
